import React, { createContext, useState, useRef, useEffect } from 'react';

export const ToastContext = createContext();

export const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState({
    show: false,
    message: '',
    type: 'success', // success, error, warning, info
    delay: 3000
  });

  const timeoutRef = useRef(null);

  const showToast = (message, type = 'success', delay = 3000) => {
    // Clear old timeout if toast is still active
    if (timeoutRef.current) clearTimeout(timeoutRef.current);

    setToast({ show: true, message, type, delay });

    // Auto hide after delay
    timeoutRef.current = setTimeout(() => {
      setToast(prev => ({ ...prev, show: false }));
    }, delay);
  };

  const hideToast = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    setToast(prev => ({ ...prev, show: false }));
  };

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, []);

  return (
    <ToastContext.Provider value={{ showToast, hideToast, toast }}>
      {children}
    </ToastContext.Provider>
  );
};
